import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogPortal,
} from "@/components/ui/dialog"
import { ApplicationDeadlineSettings } from "./ApplicationDeadlineSettings"

interface ApplicationDeadlineSettingsModalProps {
    open: boolean
    onOpenChange: (open: boolean) => void
}

export function ApplicationDeadlineSettingsModal({
    open,
    onOpenChange,
}: ApplicationDeadlineSettingsModalProps) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogPortal>
                <DialogContent className="sm:max-w-[600px]">
                    <DialogHeader>
                        <DialogTitle className="text-lg font-semibold mb-2">
                            Application Settings
                        </DialogTitle>
                        <hr />
                    </DialogHeader>
                    <ApplicationDeadlineSettings />
                </DialogContent>
            </DialogPortal>
        </Dialog>
    )
}
